import { forwardRef } from "react"
import { useSwiper } from 'swiper/react'
// const { useSwiper } =  require("swiper/react") 

/* Protopia Ecosystem component */
export interface IPrevButtonProps {
    onClick: () => void  
}
const Prev = forwardRef((props: IPrevButtonProps, ref:any): JSX.Element => { 
    const swiper = useSwiper()
    const onClick = () => { 
        swiper.slidePrev()
        props.onClick()
    }
    return <div className='position-absolute unvisibled' onClick={onClick} ref={ref} />
})
export default Prev 